import { SitemapOutlineIcon } from './SitemapOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 34B0F8F6-2E20-4B64-B683-2B1789140CA9
 * name sitemap-outline
 * version: 6.5.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/sitemap-outline.svg
 * tags
 */
export const WorkflowOutlineIcon = SitemapOutlineIcon;
export default WorkflowOutlineIcon